import { send } from 'server';

import * as helpers from '../helpers';

export const getTaxableWinnings = ({ startDate, endDate, product }) => send({
    ID: 35841,
    responses: [35842, 35843],
    description: 'Get Taxable Winnings',
    operationType: 'All',
    startDate: helpers.formatDateForIms(startDate),
    endDate: helpers.formatDateForIms(endDate),
    product
});
